<template>
  <div class="container" v-show="loaded">
    <div class="bb_topPanel">
      <img class="bb_topPanel_leftImg" src="../../assets/images/base/logo_home.png" />
      <div class="bb_topPanel_rightcm" v-show="bbtopPanelrightcm" @click="tovip()">开通会员</div>
    </div>
    <div class="bb_brand">
      <img class="bb_brand_bg" :src="stadium_brand.thumb" />
      <div class="bb_brand_inst">
        <div class="bb_brand_inst_title">品牌合作</div>
        <div class="bb_brand_inst_contAuto">
          <div class="bb_brand_inst_contAutoseat"></div>
          <div v-for="(item,index) in hotailInarr">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="bb_brandNum">
      <div>全国已合作<span>{{stadium.length}}</span>家{{stadium_brand.name}}</div>
    </div>
    <div class="clearboth"></div>
    <div class="bb_brandList">
      <div v-for="(itemCity,indexC) in cityList" :key="indexC" class="bb_brandList_item">
        <div :class="[{'bb_brandList_item_titleM':indexC>0},'bb_brandList_item_title']">
          <div :class="indexC%2==1?'bb_brandList_item_title_right':'bb_brandList_item_title_left'">{{itemCity}}</div>
        </div>
        <div v-for="(item,index) in stadium" :key="index" v-if="item.city==itemCity" class="bb_brandList_item_cont">
          <div :class="[{'bb_brandList_item_cont_imgR':index%2==0},'bb_brandList_item_cont_img']" @click="toFullPage(item,index)">
            <div :class="index%2==0?'bb_brandList_item_cont_img_borderR':'bb_brandList_item_cont_img_border'"></div>
            <div :class="index%2==0?'bb_brandList_item_cont_img_hotailR':'bb_brandList_item_cont_img_hotail'" :style="'background-image: url('+item.thumb+')'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="usernoncardstatusbtnMore" @click="toReserves()">查看更多五星级酒店</div>
    <div class="bb_brandBottom">
      感谢您的观赏<br />
      最终解释权归上海合伽体育科技有限公司所有
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        stadium_brand_id:'',
        stadium_brand:{},
        stadium:[],//酒店列表
        cityList:[],//城市列表
        bbtopPanelrightcm:false,
        hotailInarr:[],
        loaded:false
      }
    },
    created() { },
    watch: {},
    mounted() {
      this.stadium_brand_id=this.$route.params.stadium_brand_id
      this.isVip()
      this.getBrandHostal()
      // 分享模块，每次进入此页面都执行，
      // this.shareApp()
    },
    activated() {},
    methods: {
      toReserves(){
        this.$router.push({
          name:'reserve'
        })
      },
      tovip(){
        this.$router.push({
          name:'vip'
        })
      },
      // 判断用户是否是会员
      isVip(){
        var $this = this
        // console.log($this.$store.state.list_myCards)
        // $this.$store.commit('setMyCards',result.data.cards)
        // console.log($this.$store.state.list_myCards)

        if(localStorage.getItem("token")){


          // let param = {
          //   token: localStorage.getItem("token"),
          // }
          // var qs = require('qs');
          // let url = this.api.userApi.getUserCards
          // this.axios.post(url,qs.stringify(param),)
          // .then((res) => {
          //   console.log(res)
          //   if(res.code==0){
          //     if(res.data.cards.length>0){
          //       $this.bbtopPanelrightcm=false
          //       $this.$store.commit('setMyCards',res.data.cards)
          //     }else{
          //       $this.bbtopPanelrightcm=true
          //     }
          //   }else{
          //     $this.$toast(res.msg);
          //   }
          // }).catch((error) => {
          //   console.warn(error)
          //   $this.$toast(res.msg);
          // })

          if($this.$store.state.array_mycard.length==0){
            let param = {
              token: localStorage.getItem("token")
            }
            var qs = require('qs');
            let url = this.api.userApi.flUserCardsList
            this.axios.post(url, qs.stringify(param), )
            .then((result) => {
              if (result.code==0) {
                console.log(result)
                if(result.data&&result.data.length>0){
                  console.log('有会员卡')
                  $this.bbtopPanelrightcm=false
                  $this.$store.commit('updataMycard',result.data)
                }else{
                  console.log('无会员卡')
                  $this.bbtopPanelrightcm=true
                }
              } else {
                $this.$toast(result.msg)
                console.log('无会员卡')
                $this.bbtopPanelrightcm=true
              }
            }).catch((error) => {
              // console.warn(error)
            })
          }else{
            $this.bbtopPanelrightcm=false
          }


          // if($this.$store.state.list_myCards.length==0){

          // }else{
          //   $this.bbtopPanelrightcm=false
          // }


        }else{
          this.bbtopPanelrightcm=true
        }
      },
      // 获取品牌数据
      getBrandHostal(){
        var $this = this
        let param = {
          stadium_brand_id:this.stadium_brand_id
        }
        var qs = require('qs');
        let url = this.api.userApi.getBrandList
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          // console.log(result)
          if(result.code==0){
            $this.stadium_brand=result.data.stadium_brand
            $this.stadium=result.data.stadiums
            var cityArr = []
            for (var i = 0; i < $this.stadium.length; i++) {
              cityArr.push($this.stadium[i].city)
            }
            for (var i = 0; i < cityArr.length; i++) {
              for (var j = i+1; j < cityArr.length; j++) {
                if(cityArr[i]==cityArr[j]){
                  cityArr.splice(j,1)
                  j--
                }
              }
            }
            $this.cityList=cityArr
            var hotailInstr=result.data.stadium_brand.introduce
            $this.hotailInarr=hotailInstr.split('<br />')
            $this.loaded=true

          }else{
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
      toFullPage(item,index){
        // sessionStorage.setItem('fullpage_date_mode',JSON.stringify(param))
        this.$router.push({
          name:'resdetail',
          params:{
            stadium_id:item.stadium_id
          }
        })
        return
        let params={
          stadium_id:item.stadium_id,
          index:index,
          stadium_brand_id:item.stadium_brand_id
        }
        // console.log(params)
        this.$router.push({
          name:'resdetailbrand',
          params:params
        })
      },
      // 分享模块
      shareApp(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              console.log(res)
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              console.log(res)
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              console.log(res)
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              console.log(res)
            }
          });
        }
      }
    }
  }
</script>
<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .bb_topPanel{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height:80*@vm_base;
    background:rgba(0,0,0,0.2);
    z-index: 99;
    .bb_topPanel_leftImg{
      width: 134*@vm_base;
      height: 50*@vm_base;
      float: left;
      margin-left: 32*@vm_base;
      margin-top: 15*@vm_base;
    }
    .bb_topPanel_rightcm{
      width: 150*@vm_base;
      height: 50*@vm_base;
      line-height: 50*@vm_base;
      text-align: center;
      float: right;
      margin-right: 32*@vm_base;
      margin-top: 15*@vm_base;

      border-radius:6*@vm_base;
      border:1*@vm_base solid rgba(255,255,255,0.8);

      font-size:26*@vm_base;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,0.8);
    }
  }
  .bb_brand{
    width: 100%;
    position: relative;
    .bb_brand_bg{
      width: calc(100% + 2*@vm_base);
      margin-left: -2*@vm_base;
    }
    .bb_brand_inst{
      margin-top: -280*@vm_base;
      margin-bottom: 80*@vm_base;
      margin-left: 40*@vm_base;
      .bb_brand_inst_title{
        width:170*@vm_base;
        height:60*@vm_base;
        background:rgba(0,0,0,1);
        font-size:32*@vm_base;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:60*@vm_base;
        text-align: center;
        margin-bottom: 54*@vm_base;
      }
      .bb_brand_inst_cont{
        font-size:26*@vm_base;
        width: 423*@vm_base;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:37*@vm_base;
      }
      .bb_brand_inst_contAuto{
        font-size:26*@vm_base;
        width: calc(100% - 40*@vm_base);
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:37*@vm_base;
        .bb_brand_inst_contAutoseat{
          width: calc(100% - 423*@vm_base);
          height: 111*@vm_base;
          float: right;
        }
      }
    }
  }
  .bb_brandNum{
    width: 100%;
    div{
      height: 86*@vm_base;
      line-height: 86*@vm_base;
      float: right;
      width:528*@vm_base;
      border-bottom: 6*@vm_base solid rgba(51,51,51,1);
      margin-top: 57*@vm_base;
      font-size:32*@vm_base;
      font-weight:400;
      color:rgba(51,51,51,1);
      span{
        font-weight: bold;
        font-size: 38*@vm_base;
      }
    }
  }
  .bb_brandList{
    width: 100%;
    padding: 84*@vm_base 0 0*@vm_base 0;
    .bb_brandList_item{
      width: 100%;
      .bb_brandList_item_title{
        width: 100%;
        height: 60*@vm_base;
        div{
          width:138*@vm_base;
          height:60*@vm_base;
          line-height: 60*@vm_base;
          text-align: center;
          background:rgba(51,51,51,1);
          font-size:28*@vm_base;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
        .bb_brandList_item_title_left{
          float: left;
        }
        .bb_brandList_item_title_right{
          float: right;
        }
      }
      .bb_brandList_item_titleM{
        margin-top: 20*@vm_base;
      }
      .bb_brandList_item_cont{
        width: 100%;
        text-align: right;
        .bb_brandList_item_cont_img{
          width: 690*@vm_base;
          height: 446*@vm_base;
          margin-bottom: 80*@vm_base;
          position: relative;
          margin-left: 0;
          .bb_brandList_item_cont_img_border{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 650*@vm_base;
            height: 406*@vm_base;
            border: 2*@vm_base solid rgba(69,63,86,1);
          }
          .bb_brandList_item_cont_img_borderR{
            position: absolute;
            bottom: 0;
            right: 0;
            width: 650*@vm_base;
            height: 406*@vm_base;
            border: 2*@vm_base solid rgba(69,63,86,1);
          }
          .bb_brandList_item_cont_img_hotail{
            position: absolute;
            top: 0;
            right: 0;
            width: 650*@vm_base;
            height: 406*@vm_base;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: auto 100%;
          }
          .bb_brandList_item_cont_img_hotailR{
            position: absolute;
            top: 0;
            left: 0;
            width: 650*@vm_base;
            height: 406*@vm_base;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: auto 100%;
          }
        }
        .bb_brandList_item_cont_imgR{
          margin-left: 60*@vm_base;
        }
      }
    }
  }
  .bb_brandBottom{
    width: 100%;
    text-align: center;
    font-size:24*@vm_base;
    font-weight:400;
    color:rgba(68,64,84,1);
    line-height:33*@vm_base;
    margin-bottom: 40*@vm_base;
  }
  .usernoncardstatusbtnMore{
    width: 90%;
    height: 80*@vm_base;
    line-height: 80*@vm_base;
    text-align: center;
    color: #FFFFFF;
    background: #444054;
    font-size: 32*@vm_base;
    border-radius: 12*@vm_base;
    margin: 0 auto;
    margin-bottom: 40*@vm_base;
    margin-left: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/brand/brand.vue